import type { AttributeDTO } from '@psw/shared';

export class Attribute implements AttributeDTO {
  subtype: 'Accreditation' | 'Allergy_Compliance' | 'Component' | 'Filter' | 'Other';
  unit: string | null;
  value: string | number | string[] | number[] | null;
  _id: string;

  constructor(attribute: AttributeDTO) {
    if (!attribute._id) throw new Error('Attribute _id is required');
    this.subtype = attribute.subtype;
    this.unit = attribute.unit;
    this.value = attribute.value;
    this._id = attribute._id;
  }

  printWithUnit(): string {
    return `${this.value}${this.unit}`;
  }
}
